module.exports = __webpack_public_path__ + "static/img/detailback.e7b5864.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/detailback.png
// module id = tD88
// module chunks = 1